import { Box, FormControlLabel, Checkbox, Typography } from "@mui/material";
import { WidgetProps } from "@rjsf/utils";
import { renderDescriptionTooltip } from "./common";

// Full-width Checkbox Widget - standalone with more prominence
export const WideCheckboxWidget = (props: WidgetProps) => {
  const { id, value, label, onChange, required, disabled, readonly, schema } = props;

  return (
    <Box sx={{ py: 1 }}>
      <FormControlLabel
        control={
          <Checkbox
            id={id}
            checked={!!value}
            onChange={(event) => onChange(event.target.checked)}
            disabled={disabled || readonly}
            color="primary"
          />
        }
        label={
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography variant="body1" component="span">
              {label || ""}
              {required && (
                <Typography component="span" color="error.main" sx={{ ml: 0.5 }}>
                  *
                </Typography>
              )}
            </Typography>
            {renderDescriptionTooltip(schema.description)}
          </Box>
        }
        sx={{
          m: 0,
          width: "100%",
        }}
      />
    </Box>
  );
};
